import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Card from '../../../Card';

import { VerticalStepperSkeletonProps } from './VerticalStepperSkeleton.types';

const VerticalStepperSkeleton: React.FC<VerticalStepperSkeletonProps> = ({ className, steps }) => {
  return (
    <Card className={`relative flex flex-justify p4 ${className}`}>
      <div className="flex flex-column">
        {Array(steps)
          .fill(0)
          .map((_el, ind) => (
            <Skeleton
              variant="rect" 
              key={ind}
              width={120}
              height={16}
              className={`mx3 ${ind !== steps - 1 ? 'mb3' : ''}`}
            />
          ))}
      </div>

      <Skeleton variant="circle" width={36} height={36} />
    </Card>
  );
};

export default VerticalStepperSkeleton;
export { VerticalStepperSkeletonProps };
